namespace app.tarefas.minhasTarefas {

    import IDialogService = ng.material.IDialogService;
    
    export class UpdateTagsController {
        
        public selectedTag: ITaskTag = null;
        public name: string = null;
        public color: string = null;
        public tooltip: string = null;
        
        /** @ngInject **/
        constructor(private $mdDialog: IDialogService,
            public tags: ITaskTag[]) {
        }

        public updateTag(): void {
            this.$mdDialog.hide({
                ...angular.copy(this.selectedTag),
                color: this.color,
                name: this.name,
                tooltip: this.tooltip
            } as ITaskTag);

            this.selectedTag.name = this.name;
            this.selectedTag.color = this.color;
            this.selectedTag.tooltip = this.tooltip;
            this.selectedTag = null;
        }

        public selectTag(): void {
            if (!!this.selectedTag) {
                if (this.selectedTag.color === "blue") {
                    this.color = "#0000ff";
                } else {
                    this.color = this.selectedTag.color;
                }
                this.name = this.selectedTag.name;
                this.tooltip = this.selectedTag.tooltip;
            }
        }
        
        public closeDialog(): void {
            this.$mdDialog.cancel();
        }
        
    }
    
    angular
        .module("app.tarefas.minhas-tarefas")
        .controller("app.tarefas.minhas-tarefas.UpdateTagsController", UpdateTagsController);
}